// src/components/blog/BlogGrid.tsx
import styled from 'styled-components';

/** One column on phones, two on tablets, three on desktop. */
const BlogGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 48px 32px;

  @media (min-width: 640px) {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  @media (min-width: 1024px) {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
`;

export default BlogGrid;
